import { CSSProperties, ReactNode, FunctionComponent, useMemo } from 'react';
import { twMerge } from 'src/utils/twMerge';
import styles from './Overlay.module.scss';

type Props = {
  onClick?: () => void;
  className?: string;
  zIndex?: number | string;
  isFadeIn?: boolean;
  'aria-hidden'?: boolean;
  'data-testid'?: string;
  children?: ReactNode;
};

const Overlay: FunctionComponent<Props> = ({
  onClick,
  className,
  zIndex,
  isFadeIn = false,
  'aria-hidden': ariaHidden,
  'data-testid': dataTestId,
  children,
}) => {
  const style = useMemo<CSSProperties | undefined>(
    () => (zIndex === undefined ? undefined : { zIndex }),
    [zIndex],
  );
  return (
    <div
      role="presentation"
      className={twMerge('fixed inset-0 bg-overlay', isFadeIn && styles.fadeIn, className)}
      style={style}
      onClick={onClick}
      aria-hidden={ariaHidden}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};

export default Overlay;
